// context
// components
// styles
import { SText, STitle } from "../../styles"
import { useTranslation } from "react-i18next"
// types
// utils

const LicensePending = () => {
  const { t } = useTranslation()

  return (
    <div>
      <STitle>{t("onboarding:licensePending:title")}</STitle>
      <SText variant="h5">{t("onboarding:licensePending:textFirstPart")}</SText>
    </div>
  )
}

export default LicensePending
